import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select } from '../../../components/Form';
import { required } from '../../../utils/validation';

import { CountryShape } from './type';

const EditLegacyOfficialFields = ({ countries }) => {
    return (
        <>
            <Input
                label="First Name *"
                id="firstName"
                field="firstName"
                validate={required}
                data-testid="draw-edit.first-name-input"
            />
            <Input
                label="Last Name *"
                id="lastName"
                field="lastName"
                validate={required}
                    data-testid="draw-edit.last-name-input"
            />
            <Select
                id="countryId"
                field="countryId"
                options={countries}
                validate={required}
                emptyOption="Select Country"
                attributeToShow="description"
                label={`Country *`}
                    data-testid="draw-edit.country-id-select"
            />
        </>
    );
};

EditLegacyOfficialFields.propTypes = {
    countries: PropTypes.arrayOf(PropTypes.shape(CountryShape)).isRequired,
};

export default EditLegacyOfficialFields;
